module.exports = "/lucky-balls/img/risk.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/risk.png
// module id = 1154
// module chunks = 0